import React, { useEffect, useState } from 'react';
import { Button, Card, Empty, Form, Input, InputNumber, message, Modal, Select, Spin } from "antd";
import Swal from "sweetalert2";

function BulkApproval(props) {

    const { getFieldDecorator, validateFields } = props.form;
    const {
        pvId,
        showBulkApprove,
        toggleBulkApprovalShow,
        pvData,
        loading,
        ownerData,
        processApproval,
        bulkProcessJob
    } = props;

    const [job, setJob] = useState(null)
    const [api, setApi] = useState(process.env.REACT_APP_ENVIRONMENT === `development`
        ? `http://localhost:3002/v2/`
        : process.env.REACT_APP_ENVIRONMENT === `production`
            ? `https://api.theassetpro.com/v2/`
            : `https://api.quonitrix.com/v2/`,)

    useEffect(() => {
        setJob(null)
    }, []);


    useEffect(() => {
        // console.log(bulkProcessJob)
        if (bulkProcessJob) {
            setJob(bulkProcessJob && bulkProcessJob.id)
        }
    }, [bulkProcessJob]);


    // Report the background-job running state up so the parent can disable this PV's row-level
    // Approve button while the job is in flight (and re-enable it once the job finishes).
    useEffect(() => {
        if (props.onJobRunningChange) {
            props.onJobRunningChange(pvId, !!job);
        }
    }, [job]);


    useEffect(() => {
        if (job) {
            // console.log(`${api}pre-verification-approval/sse?job=${job}`)
            const eventSource = new EventSource(`${api}common/sse-job-status?job=${job}`);

            eventSource.onmessage = (event) => {
                const data = JSON.parse(event.data);
                // console.log('Received message from server:', data);
                if (data && data.state) {
                    message.loading({ content: 'Loading...', key: 'updatable' });
                }
                if (data && data.state && ['completed', 'failed', 'not_found'].includes(data.state)) {
                    // console.log(data.response)
                    message.success({ content: 'Completed', key: 'updatable', duration: 2 });
                    eventSource.close();
                    setJob(null);
                    // Job finished: re-enable the flow by closing the modal (the result Swal below
                    // shows the outcome). Guarded so it only closes while the modal is open.
                    if (showBulkApprove && toggleBulkApprovalShow) {
                        toggleBulkApprovalShow();
                    }
                    if (data.result) {
                        Swal.fire({
                            title: `Approval Log for ${pvData.pvNo}`,
                            html: `<pre style="max-height: 300px; overflow-y: scroll; font-size: small">${JSON.stringify(data.result, null, 1)}</pre>`,
                            confirmButtonText: 'Close'
                        });
                    }
                }
            };

            eventSource.onerror = (error) => {
                console.error('SSE error:', error);
                eventSource.close();
                setJob(null);
            };

            return () => {
                eventSource.close();
                setJob(null);
            };
        }
    }, [job]);

    const handleSubmit = (e) => {
        e.preventDefault();
        props.form.validateFields((err, values) => {
            if (err) {
                return console.log(err);
            }
            // console.log(values);
            processApproval({ ...values, pvId });
            // Keep the modal open with the Approve button disabled + spinner until the background
            // job reports Completed (handled in the SSE effect). This prevents a re-submit of the
            // same PV before the user has seen the outcome email/notification.
        });
    }

    return (
        <div>
            <Modal
                title="PV Bulk Approve"
                visible={showBulkApprove}
                onCancel={toggleBulkApprovalShow}
                footer={null}>

                <Spin spinning={loading || !!job}>
                    {pvData && !pvData.isApproved && !pvData.approval ?
                        <Card className={`gx-card-metrics`}
                            title={`Enter default data for ${pvData.assetDetails && pvData.assetDetails.length} assets in ${pvData.pvNo} for Bulk Approval`}>
                            <Form onSubmit={handleSubmit} layout="vertical">
                                <Form.Item key={`ownedBy`} label={'Owned By'}>
                                    {getFieldDecorator(`ownedBy`, {
                                        rules: [{
                                            required: true,
                                            message: `Owner is required!`
                                        }],
                                        initialValue: '',
                                    })(
                                        <Select
                                            showSearch
                                            allowClear
                                            mode="single"
                                            style={{ width: '75%' }}
                                            filterOption={(input, option) =>
                                                (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                            }
                                            placeholder={`Please Select Owner`}
                                        >
                                            {ownerData && ownerData.length && ownerData.map(itm =>
                                                <Select.Option key={itm._id}
                                                    value={itm._id}>{itm.name}</Select.Option>)}
                                        </Select>
                                    )
                                    }
                                </Form.Item>
                                <Form.Item key={`invoice_value`} label={'Invoice Value'}>
                                    {getFieldDecorator(`rate`, {
                                        rules: [{
                                            required: true,
                                            message: `Invoice Value is required!`
                                        }],
                                        initialValue: 0,
                                    })(<InputNumber min={0} placeholder={'Invoice Value'} style={{ width: '100%' }} />)
                                    }
                                </Form.Item>
                                <Form.Item>
                                    <Button type="primary" htmlType="submit" className="gx-mb-0" disabled={!!job || loading}>
                                        {`Approve ${pvData.assetDetails && pvData.assetDetails.length} asset/s in ${pvData.pvNo}`}
                                    </Button>
                                </Form.Item>

                                {job ? (
                                    <p style={{ color: '#faad14', marginTop: 8 }}>
                                        Approval is running in the background. A confirmation email/notification will be
                                        sent when it finishes. Please do <b>not</b> retry until you have checked the
                                        email/notification for this PV's status.
                                    </p>
                                ) : null}

                            </Form>
                        </Card>
                        :
                        <Card>
                            {pvData.isApproved ? <p>Already processed!</p> :
                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                        </Card>
                    }
                </Spin>
            </Modal>

        </div>
    );
}

const BulkApprovalForm = Form.create({ name: 'bulk_approval_form' })(BulkApproval);

export default BulkApprovalForm;
